import React, { useState, useMemo, useEffect } from 'react';
import { Box, Typography, MenuItem } from '@mui/material';
import { CustomButton, StandardChip, CustomSelect } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
// import { getLanguagesAction } from '../../API/Action';
import CustomChip from '../../../Components/CustomChip';

const questionConfig = getQuestionConfig(ProfilerQuestionID.PREFERRED_LANGUAGE);

const PrefferedLanguage = ({
  questionId = ProfilerQuestionID.PREFERRED_LANGUAGE,
  title = questionConfig?.question,
  subtitle = '',
  value,
  defaultValue = [],
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  options = { preferred: [], others: [] },
}) => {
  const isControlled = Array.isArray(value);
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selected = isControlled ? value : internalValue;
  function normalizeOptions(opts) {
    if (!Array.isArray(opts)) return [];
    if (opts.length === 0) return [];
    if (typeof opts[0] === 'string') {
      return opts.map(l => ({ value: l, label: l }));
    }
    return opts;
  }
  // Use only options prop for languageOptions
  const preferred = normalizeOptions(options.preferred);
  const others = normalizeOptions(options.others);

  const handleSelect = (lang) => {
    // Always deduplicate
    let next = Array.isArray(selected) ? [...selected, lang] : [lang];
    // If selected is array of objects, dedupe by value
    if (typeof lang === 'object' && lang.value) {
      const seen = new Set();
      next = next.filter(item => {
        const val = typeof item === 'object' ? item.value : item;
        if (seen.has(val)) return false;
        seen.add(val);
        return true;
      });
    } else {
      // Dedupe primitives
      next = Array.from(new Set(next));
    }
    if (!isControlled) setInternalValue(next);
    onChange?.(next);
  };
  const handleRemove = (lang) => {
    const next = selected.filter(l => l !== lang);
    if (!isControlled) setInternalValue(next);
    onChange?.(next);
  };
  const unselectedPreferred = preferred.filter(opt => !selected.includes(opt.value));
  const availableOthers = others.filter(opt => !selected.includes(opt.value));

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selected }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
        <Box component='img' alt='Preffered language' width={200} src={PROFILER_IMAGES.preffered_language}  />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
          <CardHeader title={title} subtitle={subtitle} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {console.log(selected)}
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {selected.map((lang, idx) => {
                let value, label;
                if (typeof lang === 'object' && lang !== null) {
                  value = lang.value;
                  label = lang.label || lang.value;
                } else {
                  value = lang;
                  label = lang;
                }
                  return (
                    <CustomChip
                      key={value}
                      label={label}
                      selected={true}
                      onDelete={() => handleRemove(value)}
                    />
                );
              })}
              {unselectedPreferred.map(opt => (
                <CustomChip
                  key={opt.value}
                  label={opt.label}
                  onClick={() => handleSelect(opt.value)}
                />
              ))}
            </Box>
            {availableOthers.length > 0 && (
              <CustomSelect
                fullWidth
                size="small"
                value={''}
                displayEmpty
                onChange={e => handleSelect(e.target.value)}
                placeholder={'Choose additional languages'}
              >
                {availableOthers.map(opt => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                ))}
              </CustomSelect>
            )}
          </Box>
        </Box>
        <CustomButton
          size='small'
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selected.length}
          sx={{ width: '100%', mt: 'auto', pt: 1 }}
        />
      </Box>
    </Box>
  );
};

export default PrefferedLanguage;
